import { Image as ImageView } from 'react-bootstrap'
import { useState } from 'react'

export const PreviewFile = ({ file }) => {
  const [preview, setPreview] = useState(null)

  if (!file) return null

  const reader = new FileReader()

  reader.readAsDataURL(file)

  reader.onload = () => {
    setPreview(file ? reader.result : null)
  }

  return <ImageView src={preview} style={{ aspectRatio: 1, width: '100%', marginTop: 16, borderRadius: 12 }} />
}
